<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.95 9.8833L5.83335 20L15.95 30.1166" stroke="#2B2F31" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M34.167 20H6.11699" stroke="#2B2F31" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
